/** @format */

const ThemeForms = () => (
  <section id="forms">
    <h2 className="sticky-xl-top fw-bold pt-3 pt-xl-5 pb-2 pb-xl-3">Forms</h2>

    <article className="my-3" id="overview">
      <div className="bd-heading sticky-xl-top align-self-start mt-5 mb-3 mt-xl-0 mb-xl-2">
        <h3>Overview</h3>
        <a className="d-flex align-items-center" href="../forms/overview/">
          Documentation
        </a>
      </div>

      <div>
        <div className="bd-example-snippet bd-code-snippet">
          <div className="bd-example">
            <form>
              <div className="mb-3">
                <label htmlFor="exampleInputEmail1" className="form-label">
                  Email address
                </label>
                <input
                  type="email"
                  className="form-control"
                  id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                />
                <div id="emailHelp" className="form-text">
                  We'll never share your email with anyone else.
                </div>
              </div>
              <div className="mb-3">
                <label htmlFor="exampleInputPassword1" className="form-label">
                  Password
                </label>
                <input
                  type="password"
                  className="form-control"
                  id="exampleInputPassword1"
                />
              </div>
              <div className="mb-3">
                <label htmlFor="exampleSelect" className="form-label">
                  Select menu
                </label>
                <select
                  className="form-select"
                  id="exampleSelect"
                  defaultValue="Open this select menu"
                >
                  <option value="1">One</option>
                  <option value="2">Two</option>
                  <option value="3">Three</option>
                </select>
              </div>
              <div className="mb-3 form-check">
                <input
                  type="checkbox"
                  defaultChecked
                  className="form-check-input"
                  id="exampleCheck1"
                />
                <label className="form-check-label" htmlFor="exampleCheck1">
                  Check me out
                </label>
              </div>
              <fieldset className="mb-3">
                <legend>Radios buttons</legend>
                <div className="form-check">
                  <input
                    type="radio"
                    name="radios"
                    className="form-check-input"
                    id="exampleRadio1"
                  />
                  <label className="form-check-label" htmlFor="exampleRadio1">
                    Default radio
                  </label>
                </div>
                <div className="mb-3 form-check">
                  <input
                    type="radio"
                    name="radios"
                    className="form-check-input"
                    id="exampleRadio2"
                  />
                  <label className="form-check-label" htmlFor="exampleRadio2">
                    Another radio
                  </label>
                </div>
              </fieldset>
              <div className="mb-3">
                <label className="form-label" htmlFor="customFile">
                  Upload
                </label>
                <input type="file" className="form-control" id="customFile" />
              </div>
              <div className="mb-3 form-check form-switch">
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="flexSwitchCheckChecked"
                  defaultChecked
                  readOnly
                />
                <label
                  className="form-check-label"
                  htmlFor="flexSwitchCheckChecked"
                >
                  Checked switch checkbox input
                </label>
              </div>
              <div className="mb-3">
                <label htmlFor="customRange3" className="form-label">
                  Example range
                </label>
                <input
                  type="range"
                  className="form-range"
                  min="0"
                  max="5"
                  step="0.5"
                  id="customRange3"
                />
              </div>
              <button type="submit" className="btn btn-primary">
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
    </article>
    <article className="my-3" id="disabled-forms">
      <div className="bd-heading sticky-xl-top align-self-start mt-5 mb-3 mt-xl-0 mb-xl-2">
        <h3>Disabled forms</h3>
        <a
          className="d-flex align-items-center"
          href="../forms/overview/#disabled-forms"
        >
          Documentation
        </a>
      </div>

      <div>
        <div className="bd-example-snippet bd-code-snippet">
          <div className="bd-example">
            <form>
              <fieldset disabled aria-label="Disabled fieldset example">
                <div className="mb-3">
                  <label htmlFor="disabledTextInput" className="form-label">
                    Disabled input
                  </label>
                  <input
                    type="text"
                    id="disabledTextInput"
                    className="form-control"
                    placeholder="Disabled input"
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="disabledSelect" className="form-label">
                    Disabled select menu
                  </label>
                  <select id="disabledSelect" className="form-select">
                    <option>Disabled select</option>
                  </select>
                </div>
                <div className="mb-3">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      defaultChecked
                      id="disabledFieldsetCheck"
                      disabled
                    />
                    <label
                      className="form-check-label"
                      htmlFor="disabledFieldsetCheck"
                    >
                      Can't check this
                    </label>
                  </div>
                </div>
                <fieldset className="mb-3">
                  <legend>Disabled radios buttons</legend>
                  <div className="form-check">
                    <input
                      type="radio"
                      name="radios"
                      className="form-check-input"
                      id="disabledRadio1"
                      disabled
                    />
                    <label
                      className="form-check-label"
                      htmlFor="disabledRadio1"
                    >
                      Disabled radio
                    </label>
                  </div>
                  <div className="mb-3 form-check">
                    <input
                      type="radio"
                      name="radios"
                      className="form-check-input"
                      id="disabledRadio2"
                      disabled
                    />
                    <label
                      className="form-check-label"
                      htmlFor="disabledRadio2"
                    >
                      Another radio
                    </label>
                  </div>
                </fieldset>
                <div className="mb-3">
                  <label className="form-label" htmlFor="disabledCustomFile">
                    Upload
                  </label>
                  <input
                    type="file"
                    className="form-control"
                    id="disabledCustomFile"
                    disabled
                  />
                </div>
                <div className="mb-3 form-check form-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    defaultChecked
                    role="switch"
                    id="disabledSwitchCheckChecked"
                    disabled
                  />
                  <label
                    className="form-check-label"
                    htmlFor="disabledSwitchCheckChecked"
                  >
                    Disabled checked switch checkbox input
                  </label>
                </div>
                <div className="mb-3">
                  <label htmlFor="disabledRange" className="form-label">
                    Disabled range
                  </label>
                  <input
                    type="range"
                    className="form-range"
                    min="0"
                    max="5"
                    step="0.5"
                    id="disabledRange"
                  />
                </div>
                <button type="submit" className="btn btn-primary">
                  Submit
                </button>
              </fieldset>
            </form>
          </div>
        </div>
      </div>
    </article>
    <article className="my-3" id="sizing">
      <div className="bd-heading sticky-xl-top align-self-start mt-5 mb-3 mt-xl-0 mb-xl-2">
        <h3>Sizing</h3>
        <a
          className="d-flex align-items-center"
          href="../forms/form-control/#sizing"
        >
          Documentation
        </a>
      </div>

      <div>
        <div className="bd-example-snippet bd-code-snippet">
          <div className="bd-example">
            <div className="mb-3">
              <input
                className="form-control form-control-lg"
                type="text"
                placeholder=".form-control-lg"
                aria-label=".form-control-lg example"
              />
            </div>
            <div className="mb-3">
              <select
                className="form-select form-select-lg"
                aria-label=".form-select-lg example"
                defaultValue="Open this select menu"
              >
                <option value="1">One</option>
                <option value="2">Two</option>
                <option value="3">Three</option>
              </select>
            </div>
            <div className="mb-3">
              <input
                type="file"
                className="form-control form-control-lg"
                aria-label="Large file input example"
              />
            </div>
          </div>
        </div>

        <div className="bd-example-snippet bd-code-snippet">
          <div className="bd-example">
            <div className="mb-3">
              <input
                className="form-control form-control-sm"
                type="text"
                placeholder=".form-control-sm"
                aria-label=".form-control-sm example"
              />
            </div>
            <div className="mb-3">
              <select
                className="form-select form-select-sm"
                aria-label=".form-select-sm example"
                defaultValue="Open this select menu"
              >
                <option value="1">One</option>
                <option value="2">Two</option>
                <option value="3">Three</option>
              </select>
            </div>
            <div className="mb-3">
              <input
                type="file"
                className="form-control form-control-sm"
                aria-label="Small file input example"
              />
            </div>
          </div>
        </div>
      </div>
    </article>
    <article className="my-3" id="input-group">
      <div className="bd-heading sticky-xl-top align-self-start mt-5 mb-3 mt-xl-0 mb-xl-2">
        <h3>Input group</h3>
        <a className="d-flex align-items-center" href="../forms/input-group/">
          Documentation
        </a>
      </div>

      <div>
        <div className="bd-example-snippet bd-code-snippet">
          <div className="bd-example">
            <div className="input-group mb-3">
              <span className="input-group-text" id="basic-addon1">
                @
              </span>
              <input
                type="text"
                className="form-control"
                placeholder="Username"
                aria-label="Username"
                aria-describedby="basic-addon1"
              />
            </div>
            <div className="input-group mb-3">
              <input
                type="text"
                className="form-control"
                placeholder="Recipient's username"
                aria-label="Recipient's username"
                aria-describedby="basic-addon2"
              />
              <span className="input-group-text" id="basic-addon2">
                @example.com
              </span>
            </div>
            <label htmlFor="basic-url" className="form-label">
              Your vanity URL
            </label>
            <div className="input-group mb-3">
              <span className="input-group-text" id="basic-addon3">
                https://example.com/users/
              </span>
              <input
                type="text"
                className="form-control"
                id="basic-url"
                aria-describedby="basic-addon3"
              />
            </div>
            <div className="input-group mb-3">
              <span className="input-group-text">$</span>
              <input
                type="text"
                className="form-control"
                aria-label="Amount (to the nearest dollar)"
              />
              <span className="input-group-text">.00</span>
            </div>
            <div className="input-group">
              <span className="input-group-text">With textarea</span>
              <textarea
                className="form-control"
                aria-label="With textarea"
              ></textarea>
            </div>
          </div>
        </div>
      </div>
    </article>
    <article className="my-3" id="floating-labels">
      <div className="bd-heading sticky-xl-top align-self-start mt-5 mb-3 mt-xl-0 mb-xl-2">
        <h3>Floating labels</h3>
        <a
          className="d-flex align-items-center"
          href="../forms/floating-labels/"
        >
          Documentation
        </a>
      </div>

      <div>
        <div className="bd-example-snippet bd-code-snippet">
          <div className="bd-example">
            <form>
              <div className="form-floating mb-3">
                <input
                  type="email"
                  className="form-control"
                  id="floatingInput"
                  placeholder="name@example.com"
                />
                <label htmlFor="floatingInput">Email address</label>
              </div>
              <div className="form-floating">
                <input
                  type="password"
                  className="form-control"
                  id="floatingPassword"
                  placeholder="Password"
                />
                <label htmlFor="floatingPassword">Password</label>
              </div>
            </form>
          </div>
        </div>
      </div>
    </article>
    <article className="my-3" id="validation">
      <div className="bd-heading sticky-xl-top align-self-start mt-5 mb-3 mt-xl-0 mb-xl-2">
        <h3>Validation</h3>
        <a className="d-flex align-items-center" href="../forms/validation/">
          Documentation
        </a>
      </div>

      <div>
        <div className="bd-example-snippet bd-code-snippet">
          <div className="bd-example">
            <form className="row g-3">
              <div className="col-md-4">
                <label htmlFor="validationServer01" className="form-label">
                  First name
                </label>
                <input
                  type="text"
                  className="form-control is-valid"
                  id="validationServer01"
                  defaultValue="Mark"
                  required
                />
                <div className="valid-feedback">Looks good!</div>
              </div>
              <div className="col-md-4">
                <label htmlFor="validationServer02" className="form-label">
                  Last name
                </label>
                <input
                  type="text"
                  className="form-control is-valid"
                  id="validationServer02"
                  defaultValue="Otto"
                  required
                />
                <div className="valid-feedback">Looks good!</div>
              </div>
              <div className="col-md-4">
                <label
                  htmlFor="validationServerUsername"
                  className="form-label"
                >
                  Username
                </label>
                <div className="input-group has-validation">
                  <span className="input-group-text" id="inputGroupPrepend3">
                    @
                  </span>
                  <input
                    type="text"
                    className="form-control is-invalid"
                    id="validationServerUsername"
                    aria-describedby="inputGroupPrepend3"
                    required
                  />
                  <div className="invalid-feedback">
                    Please choose a username.
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <label htmlFor="validationServer03" className="form-label">
                  City
                </label>
                <input
                  type="text"
                  className="form-control is-invalid"
                  id="validationServer03"
                  required
                />
                <div className="invalid-feedback">
                  Please provide a valid city.
                </div>
              </div>
              <div className="col-md-3">
                <label htmlFor="validationServer04" className="form-label">
                  State
                </label>
                <select
                  className="form-select is-invalid"
                  id="validationServer04"
                  required
                  defaultValue="Choose..."
                >
                  <option>...</option>
                </select>
                <div className="invalid-feedback">
                  Please select a valid state.
                </div>
              </div>
              <div className="col-md-3">
                <label htmlFor="validationServer05" className="form-label">
                  Zip
                </label>
                <input
                  type="text"
                  className="form-control is-invalid"
                  id="validationServer05"
                  required
                />
                <div className="invalid-feedback">
                  Please provide a valid zip.
                </div>
              </div>
              <div className="col-12">
                <div className="form-check">
                  <input
                    className="form-check-input is-invalid"
                    type="checkbox"
                    defaultChecked
                    value=""
                    id="invalidCheck3"
                    required
                  />
                  <label className="form-check-label" htmlFor="invalidCheck3">
                    Agree to terms and conditions
                  </label>
                  <div className="invalid-feedback">
                    You must agree before submitting.
                  </div>
                </div>
              </div>
              <div className="col-12">
                <button className="btn btn-primary" type="submit">
                  Submit form
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </article>
  </section>
);

export default ThemeForms;
